export const CONNEXION = {
  titleIdentifiant: 'Identifiant',
  titlePassword: 'Mot de Passe',
  buttonLogin: 'Connexion',
  textEditor: 'Solution créée et éditée par Quadra-Diffusion',
  messageError: 'Vos informations de connexion sont erronées. Veuillez réessayer.',
  infoConnexionPortail: 'Vous n\'êtes pas autorisé à vous connecter à affixe.',
};
